import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=ca11fa6c&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca11fa6c')) {
      api.createRecord('ca11fa6c', component.options)
    } else {
      api.reload('ca11fa6c', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=ca11fa6c&", function () {
      api.rerender('ca11fa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29Vr5jAPvAp2W/JS/pricelisthelp.vue"
export default component.exports